export default __webpack_public_path__ + "static/media/shirt-1.9cde8b01.png";